import styled from 'styled-components';

export const LayoutContainer = styled.div<{ isSidebarOpen: boolean }>`
  .main-content {
    padding-left: ${({ isSidebarOpen }) => (isSidebarOpen ? '260px' : '88px')};
    transition: padding-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    /* 📱 Responsive para pantallas pequeñas */
    @media (max-width: 768px) {
      padding-left: ${({ isSidebarOpen }) => (isSidebarOpen ? '200px' : '0px')};
    }

    @media (max-width: 480px) {
      padding-left: 0px; /* Sidebar se sobrepone en móviles */
    }
  }
`;

export const ContentContainer = styled.main`
  width: 100%;
  background-color: #f8f9fa;
  min-height: 100vh;
  padding: 0; /* Agrega algo de padding interno */

  @media (max-width: 768px) {
    padding: 0px;
  }

  @media (max-width: 480px) {
    padding: 0px;
  }
`;

export const DevBadge = styled.span`
  position: fixed;
  bottom: 12px;
  right: 12px;
  z-index: 9999;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(146, 64, 14, 0.9);
  background: rgba(254, 243, 199, 0.92);
  border: 1px solid rgba(251, 191, 36, 0.5);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  pointer-events: none;
  user-select: none;
`;
